import { jsx as h, Fragment as Z, jsxs as X } from "react/jsx-runtime";
import * as a from "react";
import { useLayoutEffect as gi, useEffect as vi, useState as bi } from "react";
import * as qn from "react-dom";
import yi from "react-dom";
import { clsx as Qn } from "clsx";
import { X as wi, PanelLeft as xi } from "lucide-react";
import { u as Ci } from "./use-mobile-b816b6c7.js";
import { twMerge as Pi } from "tailwind-merge";
function Sn(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Jn(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Sn(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Sn(e[o], null);
        }
      };
  };
}
function Bu(...e) {
  return a.useCallback(Jn(...e), e);
}
var de = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Si);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(kt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(kt, { ...r, ref: t, children: n });
});
de.displayName = "Slot";
var kt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Ni(n), i = Ri(r, n.props);
    return n.type !== a.Fragment && (i.ref = t ? Jn(t, o) : o), a.cloneElement(n, i);
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
kt.displayName = "SlotClone";
var Ei = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function Si(e) {
  return a.isValidElement(e) && e.type === Ei;
}
function Ri(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Ni(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const Rn = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Nn = Qn, qt = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Nn(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((u) => {
    const d = n == null ? void 0 : n[u], f = i == null ? void 0 : i[u];
    if (d === null)
      return null;
    const m = Rn(d) || Rn(f);
    return o[u][m];
  }), c = n && Object.entries(n).reduce((u, d) => {
    let [f, m] = d;
    return m === void 0 || (u[f] = m), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, d) => {
    let { class: f, className: m, ...p } = d;
    return Object.entries(p).every((v) => {
      let [g, b] = v;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...c
      }[g]) : {
        ...i,
        ...c
      }[g] === b;
    }) ? [
      ...u,
      f,
      m
    ] : u;
  }, []);
  return Nn(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function N(...e) {
  return Pi(Qn(e));
}
const Ai = qt(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), er = a.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, i) => /* @__PURE__ */ h(
    r ? de : "button",
    {
      className: N(Ai({ variant: t, size: n, className: e })),
      ref: i,
      ...o
    }
  )
);
er.displayName = "Button";
function Te(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Oi(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function tr(...e) {
  return (t) => e.forEach((n) => Oi(n, t));
}
function Ie(...e) {
  return a.useCallback(tr(...e), e);
}
function Ti(e, t) {
  const n = a.createContext(t), r = (i) => {
    const { children: s, ...c } = i, l = a.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ h(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = a.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Qt(e, t = []) {
  let n = [];
  function r(i, s) {
    const c = a.createContext(s), l = n.length;
    n = [...n, s];
    const u = (f) => {
      var y;
      const { scope: m, children: p, ...v } = f, g = ((y = m == null ? void 0 : m[e]) == null ? void 0 : y[l]) || c, b = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ h(g.Provider, { value: b, children: p });
    };
    u.displayName = i + "Provider";
    function d(f, m) {
      var g;
      const p = ((g = m == null ? void 0 : m[e]) == null ? void 0 : g[l]) || c, v = a.useContext(p);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [u, d];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return o.scopeName = e, [r, Mi(o, ...t)];
}
function Mi(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((c, { useScope: l, scopeName: u }) => {
        const f = l(i)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Rt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Di(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function nr(...e) {
  return (t) => e.forEach((n) => Di(n, t));
}
function rr(...e) {
  return a.useCallback(nr(...e), e);
}
var or = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(_i);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(Lt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Lt, { ...r, ref: t, children: n });
});
or.displayName = "Slot";
var Lt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = ki(n);
    return a.cloneElement(n, {
      ...Ii(r, n.props),
      // @ts-ignore
      ref: t ? nr(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Lt.displayName = "SlotClone";
var $i = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function _i(e) {
  return a.isValidElement(e) && e.type === $i;
}
function Ii(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ki(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Li = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ir = Li.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? or : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Wi(e, t) {
  e && qn.flushSync(() => e.dispatchEvent(t));
}
function te(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Fi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = te(e);
  a.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Bi = "DismissableLayer", Wt = "dismissableLayer.update", Vi = "dismissableLayer.pointerDownOutside", Hi = "dismissableLayer.focusOutside", An, ar = a.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), it = a.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: c,
      ...l
    } = e, u = a.useContext(ar), [d, f] = a.useState(null), m = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = a.useState({}), v = rr(t, (E) => f(E)), g = Array.from(u.layers), [b] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(b), w = d ? g.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, C = w >= y, P = Ui((E) => {
      const A = E.target, $ = [...u.branches].some((T) => T.contains(A));
      !C || $ || (o == null || o(E), s == null || s(E), E.defaultPrevented || c == null || c());
    }, m), S = Yi((E) => {
      const A = E.target;
      [...u.branches].some((T) => T.contains(A)) || (i == null || i(E), s == null || s(E), E.defaultPrevented || c == null || c());
    }, m);
    return Fi((E) => {
      w === u.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && c && (E.preventDefault(), c()));
    }, m), a.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (An = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), On(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = An);
        };
    }, [d, m, n, u]), a.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), On());
    }, [d, u]), a.useEffect(() => {
      const E = () => p({});
      return document.addEventListener(Wt, E), () => document.removeEventListener(Wt, E);
    }, []), /* @__PURE__ */ h(
      ir.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: x ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Rt(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: Rt(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: Rt(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
it.displayName = Bi;
var zi = "DismissableLayerBranch", ji = a.forwardRef((e, t) => {
  const n = a.useContext(ar), r = a.useRef(null), o = rr(t, r);
  return a.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ h(ir.div, { ...e, ref: o });
});
ji.displayName = zi;
function Ui(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = te(e), r = a.useRef(!1), o = a.useRef(() => {
  });
  return a.useEffect(() => {
    const i = (c) => {
      if (c.target && !r.current) {
        let l = function() {
          sr(
            Vi,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Yi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = te(e), r = a.useRef(!1);
  return a.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && sr(Hi, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function On() {
  const e = new CustomEvent(Wt);
  document.dispatchEvent(e);
}
function sr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Wi(o, i) : o.dispatchEvent(i);
}
var Nt = 0;
function cr() {
  a.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Tn()), document.body.insertAdjacentElement("beforeend", e[1] ?? Tn()), Nt++, () => {
      Nt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Nt--;
    };
  }, []);
}
function Tn() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
function Gi(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function lr(...e) {
  return (t) => e.forEach((n) => Gi(n, t));
}
function Xi(...e) {
  return a.useCallback(lr(...e), e);
}
var ur = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Zi);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(Ft, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Ft, { ...r, ref: t, children: n });
});
ur.displayName = "Slot";
var Ft = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Qi(n);
    return a.cloneElement(n, {
      ...qi(r, n.props),
      // @ts-ignore
      ref: t ? lr(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Ft.displayName = "SlotClone";
var Ki = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function Zi(e) {
  return a.isValidElement(e) && e.type === Ki;
}
function qi(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Qi(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ji = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ea = Ji.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? ur : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), At = "focusScope.autoFocusOnMount", Ot = "focusScope.autoFocusOnUnmount", Mn = { bubbles: !1, cancelable: !0 }, ta = "FocusScope", Jt = a.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [c, l] = a.useState(null), u = te(o), d = te(i), f = a.useRef(null), m = Xi(t, (g) => l(g)), p = a.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  a.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (p.paused || !c)
          return;
        const C = x.target;
        c.contains(C) ? f.current = C : oe(f.current, { select: !0 });
      }, b = function(x) {
        if (p.paused || !c)
          return;
        const C = x.relatedTarget;
        C !== null && (c.contains(C) || oe(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const P of x)
            P.removedNodes.length > 0 && oe(c);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", b);
      const w = new MutationObserver(y);
      return c && w.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", b), w.disconnect();
      };
    }
  }, [r, c, p.paused]), a.useEffect(() => {
    if (c) {
      $n.add(p);
      const g = document.activeElement;
      if (!c.contains(g)) {
        const y = new CustomEvent(At, Mn);
        c.addEventListener(At, u), c.dispatchEvent(y), y.defaultPrevented || (na(sa(dr(c)), { select: !0 }), document.activeElement === g && oe(c));
      }
      return () => {
        c.removeEventListener(At, u), setTimeout(() => {
          const y = new CustomEvent(Ot, Mn);
          c.addEventListener(Ot, d), c.dispatchEvent(y), y.defaultPrevented || oe(g ?? document.body, { select: !0 }), c.removeEventListener(Ot, d), $n.remove(p);
        }, 0);
      };
    }
  }, [c, u, d, p]);
  const v = a.useCallback(
    (g) => {
      if (!n && !r || p.paused)
        return;
      const b = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (b && y) {
        const w = g.currentTarget, [x, C] = ra(w);
        x && C ? !g.shiftKey && y === C ? (g.preventDefault(), n && oe(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && oe(C, { select: !0 })) : y === w && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ h(ea.div, { tabIndex: -1, ...s, ref: m, onKeyDown: v });
});
Jt.displayName = ta;
function na(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (oe(r, { select: t }), document.activeElement !== n)
      return;
}
function ra(e) {
  const t = dr(e), n = Dn(t, e), r = Dn(t.reverse(), e);
  return [n, r];
}
function dr(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Dn(e, t) {
  for (const n of e)
    if (!oa(n, { upTo: t }))
      return n;
}
function oa(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ia(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function oe(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ia(e) && t && e.select();
  }
}
var $n = aa();
function aa() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = _n(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = _n(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function _n(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function sa(e) {
  return e.filter((t) => t.tagName !== "A");
}
var V = globalThis != null && globalThis.document ? a.useLayoutEffect : () => {
}, ca = a["useId".toString()] || (() => {
}), la = 0;
function Me(e) {
  const [t, n] = a.useState(ca());
  return V(() => {
    e || n((r) => r ?? String(la++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const ua = ["top", "right", "bottom", "left"], ie = Math.min, F = Math.max, et = Math.round, ze = Math.floor, K = (e) => ({
  x: e,
  y: e
}), da = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, fa = {
  start: "end",
  end: "start"
};
function Bt(e, t, n) {
  return F(e, ie(t, n));
}
function ne(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function re(e) {
  return e.split("-")[0];
}
function xe(e) {
  return e.split("-")[1];
}
function en(e) {
  return e === "x" ? "y" : "x";
}
function tn(e) {
  return e === "y" ? "height" : "width";
}
function ae(e) {
  return ["top", "bottom"].includes(re(e)) ? "y" : "x";
}
function nn(e) {
  return en(ae(e));
}
function pa(e, t, n) {
  n === void 0 && (n = !1);
  const r = xe(e), o = nn(e), i = tn(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = tt(s)), [s, tt(s)];
}
function ma(e) {
  const t = tt(e);
  return [Vt(e), t, Vt(t)];
}
function Vt(e) {
  return e.replace(/start|end/g, (t) => fa[t]);
}
function ha(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function ga(e, t, n, r) {
  const o = xe(e);
  let i = ha(re(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Vt)))), i;
}
function tt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => da[t]);
}
function va(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function fr(e) {
  return typeof e != "number" ? va(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function nt(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function In(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = ae(t), s = nn(t), c = tn(s), l = re(t), u = i === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, m = r[c] / 2 - o[c] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (xe(t)) {
    case "start":
      p[s] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += m * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const ba = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = In(u, r, l), m = r, p = {}, v = 0;
  for (let g = 0; g < c.length; g++) {
    const {
      name: b,
      fn: y
    } = c[g], {
      x: w,
      y: x,
      data: C,
      reset: P
    } = await y({
      x: d,
      y: f,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: p,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = w ?? d, f = x ?? f, p = {
      ...p,
      [b]: {
        ...p[b],
        ...C
      }
    }, P && v <= 50 && (v++, typeof P == "object" && (P.placement && (m = P.placement), P.rects && (u = P.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : P.rects), {
      x: d,
      y: f
    } = In(u, m, l)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: m,
    strategy: o,
    middlewareData: p
  };
};
async function $e(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: p = 0
  } = ne(t, e), v = fr(p), b = c[m ? f === "floating" ? "reference" : "floating" : f], y = nt(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), w = f === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), C = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = nt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (y.top - P.top + v.top) / C.y,
    bottom: (P.bottom - y.bottom + v.bottom) / C.y,
    left: (y.left - P.left + v.left) / C.x,
    right: (P.right - y.right + v.right) / C.x
  };
}
const ya = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = ne(e, t) || {};
    if (u == null)
      return {};
    const f = fr(d), m = {
      x: n,
      y: r
    }, p = nn(o), v = tn(p), g = await s.getDimensions(u), b = p === "y", y = b ? "top" : "left", w = b ? "bottom" : "right", x = b ? "clientHeight" : "clientWidth", C = i.reference[v] + i.reference[p] - m[p] - i.floating[v], P = m[p] - i.reference[p], S = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let E = S ? S[x] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(S))) && (E = c.floating[x] || i.floating[v]);
    const A = C / 2 - P / 2, $ = E / 2 - g[v] / 2 - 1, T = ie(f[y], $), k = ie(f[w], $), L = T, O = E - g[v] - k, M = E / 2 - g[v] / 2 + A, W = Bt(L, M, O), _ = !l.arrow && xe(o) != null && M !== W && i.reference[v] / 2 - (M < L ? T : k) - g[v] / 2 < 0, D = _ ? M < L ? M - L : M - O : 0;
    return {
      [p]: m[p] + D,
      data: {
        [p]: W,
        centerOffset: M - W - D,
        ..._ && {
          alignmentOffset: D
        }
      },
      reset: _
    };
  }
}), wa = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: g = !0,
        ...b
      } = ne(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = re(o), w = ae(c), x = re(c) === c, C = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), P = m || (x || !g ? [tt(c)] : ma(c)), S = v !== "none";
      !m && S && P.push(...ga(c, g, v, C));
      const E = [c, ...P], A = await $e(t, b), $ = [];
      let T = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && $.push(A[y]), f) {
        const M = pa(o, s, C);
        $.push(A[M[0]], A[M[1]]);
      }
      if (T = [...T, {
        placement: o,
        overflows: $
      }], !$.every((M) => M <= 0)) {
        var k, L;
        const M = (((k = i.flip) == null ? void 0 : k.index) || 0) + 1, W = E[M];
        if (W)
          return {
            data: {
              index: M,
              overflows: T
            },
            reset: {
              placement: W
            }
          };
        let _ = (L = T.filter((D) => D.overflows[0] <= 0).sort((D, R) => D.overflows[1] - R.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!_)
          switch (p) {
            case "bestFit": {
              var O;
              const D = (O = T.filter((R) => {
                if (S) {
                  const I = ae(R.placement);
                  return I === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  I === "y";
                }
                return !0;
              }).map((R) => [R.placement, R.overflows.filter((I) => I > 0).reduce((I, H) => I + H, 0)]).sort((R, I) => R[1] - I[1])[0]) == null ? void 0 : O[0];
              D && (_ = D);
              break;
            }
            case "initialPlacement":
              _ = c;
              break;
          }
        if (o !== _)
          return {
            reset: {
              placement: _
            }
          };
      }
      return {};
    }
  };
};
function kn(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ln(e) {
  return ua.some((t) => e[t] >= 0);
}
const xa = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ne(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await $e(t, {
            ...o,
            elementContext: "reference"
          }), s = kn(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Ln(s)
            }
          };
        }
        case "escaped": {
          const i = await $e(t, {
            ...o,
            altBoundary: !0
          }), s = kn(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Ln(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Ca(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = re(n), c = xe(n), l = ae(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, d = i && l ? -1 : 1, f = ne(t, e);
  let {
    mainAxis: m,
    crossAxis: p,
    alignmentAxis: v
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return c && typeof v == "number" && (p = c === "end" ? v * -1 : v), l ? {
    x: p * d,
    y: m * u
  } : {
    x: m * u,
    y: p * d
  };
}
const Pa = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, l = await Ca(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, Ea = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (b) => {
            let {
              x: y,
              y: w
            } = b;
            return {
              x: y,
              y: w
            };
          }
        },
        ...l
      } = ne(e, t), u = {
        x: n,
        y: r
      }, d = await $e(t, l), f = ae(re(o)), m = en(f);
      let p = u[m], v = u[f];
      if (i) {
        const b = m === "y" ? "top" : "left", y = m === "y" ? "bottom" : "right", w = p + d[b], x = p - d[y];
        p = Bt(w, p, x);
      }
      if (s) {
        const b = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", w = v + d[b], x = v - d[y];
        v = Bt(w, v, x);
      }
      const g = c.fn({
        ...t,
        [m]: p,
        [f]: v
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [m]: i,
            [f]: s
          }
        }
      };
    }
  };
}, Sa = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: c = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = ne(e, t), d = {
        x: n,
        y: r
      }, f = ae(o), m = en(f);
      let p = d[m], v = d[f];
      const g = ne(c, t), b = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = m === "y" ? "height" : "width", C = i.reference[m] - i.floating[x] + b.mainAxis, P = i.reference[m] + i.reference[x] - b.mainAxis;
        p < C ? p = C : p > P && (p = P);
      }
      if (u) {
        var y, w;
        const x = m === "y" ? "width" : "height", C = ["top", "left"].includes(re(o)), P = i.reference[f] - i.floating[x] + (C && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (C ? 0 : b.crossAxis), S = i.reference[f] + i.reference[x] + (C ? 0 : ((w = s.offset) == null ? void 0 : w[f]) || 0) - (C ? b.crossAxis : 0);
        v < P ? v = P : v > S && (v = S);
      }
      return {
        [m]: p,
        [f]: v
      };
    }
  };
}, Ra = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: l = () => {
        },
        ...u
      } = ne(e, t), d = await $e(t, u), f = re(o), m = xe(o), p = ae(o) === "y", {
        width: v,
        height: g
      } = i.floating;
      let b, y;
      f === "top" || f === "bottom" ? (b = f, y = m === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (y = f, b = m === "end" ? "top" : "bottom");
      const w = g - d.top - d.bottom, x = v - d.left - d.right, C = ie(g - d[b], w), P = ie(v - d[y], x), S = !t.middlewareData.shift;
      let E = C, A = P;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (A = x), (r = t.middlewareData.shift) != null && r.enabled.y && (E = w), S && !m) {
        const T = F(d.left, 0), k = F(d.right, 0), L = F(d.top, 0), O = F(d.bottom, 0);
        p ? A = v - 2 * (T !== 0 || k !== 0 ? T + k : F(d.left, d.right)) : E = g - 2 * (L !== 0 || O !== 0 ? L + O : F(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: A,
        availableHeight: E
      });
      const $ = await s.getDimensions(c.floating);
      return v !== $.width || g !== $.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function at() {
  return typeof window < "u";
}
function Ce(e) {
  return pr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Q(e) {
  var t;
  return (t = (pr(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function pr(e) {
  return at() ? e instanceof Node || e instanceof B(e).Node : !1;
}
function j(e) {
  return at() ? e instanceof Element || e instanceof B(e).Element : !1;
}
function q(e) {
  return at() ? e instanceof HTMLElement || e instanceof B(e).HTMLElement : !1;
}
function Wn(e) {
  return !at() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof B(e).ShadowRoot;
}
function ke(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = U(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Na(e) {
  return ["table", "td", "th"].includes(Ce(e));
}
function st(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function rn(e) {
  const t = on(), n = j(e) ? U(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Aa(e) {
  let t = se(e);
  for (; q(t) && !be(t); ) {
    if (rn(t))
      return t;
    if (st(t))
      return null;
    t = se(t);
  }
  return null;
}
function on() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function be(e) {
  return ["html", "body", "#document"].includes(Ce(e));
}
function U(e) {
  return B(e).getComputedStyle(e);
}
function ct(e) {
  return j(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function se(e) {
  if (Ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Wn(e) && e.host || // Fallback.
    Q(e)
  );
  return Wn(t) ? t.host : t;
}
function mr(e) {
  const t = se(e);
  return be(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : q(t) && ke(t) ? t : mr(t);
}
function _e(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = mr(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = B(o);
  if (i) {
    const c = Ht(s);
    return t.concat(s, s.visualViewport || [], ke(o) ? o : [], c && n ? _e(c) : []);
  }
  return t.concat(o, _e(o, [], n));
}
function Ht(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hr(e) {
  const t = U(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = q(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, c = et(n) !== i || et(r) !== s;
  return c && (n = i, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function an(e) {
  return j(e) ? e : e.contextElement;
}
function ge(e) {
  const t = an(e);
  if (!q(t))
    return K(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = hr(t);
  let s = (i ? et(n.width) : n.width) / r, c = (i ? et(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const Oa = /* @__PURE__ */ K(0);
function gr(e) {
  const t = B(e);
  return !on() || !t.visualViewport ? Oa : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ta(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== B(e) ? !1 : t;
}
function le(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = an(e);
  let s = K(1);
  t && (r ? j(r) && (s = ge(r)) : s = ge(e));
  const c = Ta(i, n, r) ? gr(i) : K(0);
  let l = (o.left + c.x) / s.x, u = (o.top + c.y) / s.y, d = o.width / s.x, f = o.height / s.y;
  if (i) {
    const m = B(i), p = r && j(r) ? B(r) : r;
    let v = m, g = Ht(v);
    for (; g && r && p !== v; ) {
      const b = ge(g), y = g.getBoundingClientRect(), w = U(g), x = y.left + (g.clientLeft + parseFloat(w.paddingLeft)) * b.x, C = y.top + (g.clientTop + parseFloat(w.paddingTop)) * b.y;
      l *= b.x, u *= b.y, d *= b.x, f *= b.y, l += x, u += C, v = B(g), g = Ht(v);
    }
  }
  return nt({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function sn(e, t) {
  const n = ct(e).scrollLeft;
  return t ? t.left + n : le(Q(e)).left + n;
}
function vr(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    sn(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Ma(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Q(r), c = t ? st(t.floating) : !1;
  if (r === s || c && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = K(1);
  const d = K(0), f = q(r);
  if ((f || !f && !i) && ((Ce(r) !== "body" || ke(s)) && (l = ct(r)), q(r))) {
    const p = le(r);
    u = ge(r), d.x = p.x + r.clientLeft, d.y = p.y + r.clientTop;
  }
  const m = s && !f && !i ? vr(s, l, !0) : K(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + m.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + m.y
  };
}
function Da(e) {
  return Array.from(e.getClientRects());
}
function $a(e) {
  const t = Q(e), n = ct(e), r = e.ownerDocument.body, o = F(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = F(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + sn(e);
  const c = -n.scrollTop;
  return U(r).direction === "rtl" && (s += F(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function _a(e, t) {
  const n = B(e), r = Q(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, c = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = on();
    (!u || u && t === "fixed") && (c = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function Ia(e, t) {
  const n = le(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = q(e) ? ge(e) : K(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, l = o * i.x, u = r * i.y;
  return {
    width: s,
    height: c,
    x: l,
    y: u
  };
}
function Fn(e, t, n) {
  let r;
  if (t === "viewport")
    r = _a(e, n);
  else if (t === "document")
    r = $a(Q(e));
  else if (j(t))
    r = Ia(t, n);
  else {
    const o = gr(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return nt(r);
}
function br(e, t) {
  const n = se(e);
  return n === t || !j(n) || be(n) ? !1 : U(n).position === "fixed" || br(n, t);
}
function ka(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = _e(e, [], !1).filter((c) => j(c) && Ce(c) !== "body"), o = null;
  const i = U(e).position === "fixed";
  let s = i ? se(e) : e;
  for (; j(s) && !be(s); ) {
    const c = U(s), l = rn(s);
    !l && c.position === "fixed" && (o = null), (i ? !l && !o : !l && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ke(s) && !l && br(e, s)) ? r = r.filter((d) => d !== s) : o = c, s = se(s);
  }
  return t.set(e, r), r;
}
function La(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? st(t) ? [] : ka(t, this._c) : [].concat(n), r], c = s[0], l = s.reduce((u, d) => {
    const f = Fn(t, d, o);
    return u.top = F(f.top, u.top), u.right = ie(f.right, u.right), u.bottom = ie(f.bottom, u.bottom), u.left = F(f.left, u.left), u;
  }, Fn(t, c, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Wa(e) {
  const {
    width: t,
    height: n
  } = hr(e);
  return {
    width: t,
    height: n
  };
}
function Fa(e, t, n) {
  const r = q(t), o = Q(t), i = n === "fixed", s = le(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = K(0);
  if (r || !r && !i)
    if ((Ce(t) !== "body" || ke(o)) && (c = ct(t)), r) {
      const m = le(t, !0, i, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else
      o && (l.x = sn(o));
  const u = o && !r && !i ? vr(o, c) : K(0), d = s.left + c.scrollLeft - l.x - u.x, f = s.top + c.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Tt(e) {
  return U(e).position === "static";
}
function Bn(e, t) {
  if (!q(e) || U(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Q(e) === n && (n = n.ownerDocument.body), n;
}
function yr(e, t) {
  const n = B(e);
  if (st(e))
    return n;
  if (!q(e)) {
    let o = se(e);
    for (; o && !be(o); ) {
      if (j(o) && !Tt(o))
        return o;
      o = se(o);
    }
    return n;
  }
  let r = Bn(e, t);
  for (; r && Na(r) && Tt(r); )
    r = Bn(r, t);
  return r && be(r) && Tt(r) && !rn(r) ? n : r || Aa(e) || n;
}
const Ba = async function(e) {
  const t = this.getOffsetParent || yr, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Fa(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Va(e) {
  return U(e).direction === "rtl";
}
const Ha = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ma,
  getDocumentElement: Q,
  getClippingRect: La,
  getOffsetParent: yr,
  getElementRects: Ba,
  getClientRects: Da,
  getDimensions: Wa,
  getScale: ge,
  isElement: j,
  isRTL: Va
};
function wr(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function za(e, t) {
  let n = null, r;
  const o = Q(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), i();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: m,
      height: p
    } = u;
    if (c || t(), !m || !p)
      return;
    const v = ze(f), g = ze(o.clientWidth - (d + m)), b = ze(o.clientHeight - (f + p)), y = ze(d), x = {
      rootMargin: -v + "px " + -g + "px " + -b + "px " + -y + "px",
      threshold: F(0, ie(1, l)) || 1
    };
    let C = !0;
    function P(S) {
      const E = S[0].intersectionRatio;
      if (E !== l) {
        if (!C)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !wr(u, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, x);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function xr(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = an(e), d = o || i ? [...u ? _e(u) : [], ..._e(t)] : [];
  d.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const f = u && c ? za(u, n) : null;
  let m = -1, p = null;
  s && (p = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === u && p && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = p) == null || x.observe(t);
    })), n();
  }), u && !l && p.observe(u), p.observe(t));
  let v, g = l ? le(e) : null;
  l && b();
  function b() {
    const y = le(e);
    g && !wr(g, y) && n(), g = y, v = requestAnimationFrame(b);
  }
  return n(), () => {
    var y;
    d.forEach((w) => {
      o && w.removeEventListener("scroll", n), i && w.removeEventListener("resize", n);
    }), f == null || f(), (y = p) == null || y.disconnect(), p = null, l && cancelAnimationFrame(v);
  };
}
const ja = Pa, Ua = Ea, Ya = wa, Ga = Ra, Xa = xa, Vn = ya, Ka = Sa, Za = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Ha,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return ba(e, t, {
    ...o,
    platform: i
  });
};
var qe = typeof document < "u" ? gi : vi;
function rt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!rt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !rt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Cr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Hn(e, t) {
  const n = Cr(e);
  return Math.round(t * n) / n;
}
function Mt(e) {
  const t = a.useRef(e);
  return qe(() => {
    t.current = e;
  }), t;
}
function Pr(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, f] = a.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = a.useState(r);
  rt(m, r) || p(r);
  const [v, g] = a.useState(null), [b, y] = a.useState(null), w = a.useCallback((R) => {
    R !== S.current && (S.current = R, g(R));
  }, []), x = a.useCallback((R) => {
    R !== E.current && (E.current = R, y(R));
  }, []), C = i || v, P = s || b, S = a.useRef(null), E = a.useRef(null), A = a.useRef(d), $ = l != null, T = Mt(l), k = Mt(o), L = Mt(u), O = a.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const R = {
      placement: t,
      strategy: n,
      middleware: m
    };
    k.current && (R.platform = k.current), Za(S.current, E.current, R).then((I) => {
      const H = {
        ...I,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: L.current !== !1
      };
      M.current && !rt(A.current, H) && (A.current = H, qn.flushSync(() => {
        f(H);
      }));
    });
  }, [m, t, n, k, L]);
  qe(() => {
    u === !1 && A.current.isPositioned && (A.current.isPositioned = !1, f((R) => ({
      ...R,
      isPositioned: !1
    })));
  }, [u]);
  const M = a.useRef(!1);
  qe(() => (M.current = !0, () => {
    M.current = !1;
  }), []), qe(() => {
    if (C && (S.current = C), P && (E.current = P), C && P) {
      if (T.current)
        return T.current(C, P, O);
      O();
    }
  }, [C, P, O, T, $]);
  const W = a.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: w,
    setFloating: x
  }), [w, x]), _ = a.useMemo(() => ({
    reference: C,
    floating: P
  }), [C, P]), D = a.useMemo(() => {
    const R = {
      position: n,
      left: 0,
      top: 0
    };
    if (!_.floating)
      return R;
    const I = Hn(_.floating, d.x), H = Hn(_.floating, d.y);
    return c ? {
      ...R,
      transform: "translate(" + I + "px, " + H + "px)",
      ...Cr(_.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: H
    };
  }, [n, c, _.floating, d.x, d.y]);
  return a.useMemo(() => ({
    ...d,
    update: O,
    refs: W,
    elements: _,
    floatingStyles: D
  }), [d, O, W, _, D]);
}
const qa = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Vn({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Vn({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Er = (e, t) => ({
  ...ja(e),
  options: [e, t]
}), Sr = (e, t) => ({
  ...Ua(e),
  options: [e, t]
}), Rr = (e, t) => ({
  ...Ka(e),
  options: [e, t]
}), Nr = (e, t) => ({
  ...Ya(e),
  options: [e, t]
}), Ar = (e, t) => ({
  ...Ga(e),
  options: [e, t]
}), Or = (e, t) => ({
  ...Xa(e),
  options: [e, t]
}), Tr = (e, t) => ({
  ...qa(e),
  options: [e, t]
});
var cn = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Ja);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(zt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(zt, { ...r, ref: t, children: n });
});
cn.displayName = "Slot";
var zt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = ts(n);
    return a.cloneElement(n, {
      ...es(r, n.props),
      // @ts-ignore
      ref: t ? tr(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
zt.displayName = "SlotClone";
var Qa = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function Ja(e) {
  return a.isValidElement(e) && e.type === Qa;
}
function es(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ts(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ns = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Le = ns.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? cn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), rs = "Arrow", Mr = a.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ h(
    Le.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ h("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Mr.displayName = rs;
var os = Mr;
function is(e, t = []) {
  let n = [];
  function r(i, s) {
    const c = a.createContext(s), l = n.length;
    n = [...n, s];
    function u(f) {
      const { scope: m, children: p, ...v } = f, g = (m == null ? void 0 : m[e][l]) || c, b = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ h(g.Provider, { value: b, children: p });
    }
    function d(f, m) {
      const p = (m == null ? void 0 : m[e][l]) || c, v = a.useContext(p);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [u, d];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return o.scopeName = e, [r, as(o, ...t)];
}
function as(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((c, { useScope: l, scopeName: u }) => {
        const f = l(i)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Dr(e) {
  const [t, n] = a.useState(void 0);
  return V(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, c;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          s = u.inlineSize, c = u.blockSize;
        } else
          s = e.offsetWidth, c = e.offsetHeight;
        n({ width: s, height: c });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var ln = "Popper", [$r, _r] = is(ln), [ss, Ir] = $r(ln), kr = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = a.useState(null);
  return /* @__PURE__ */ h(ss, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
kr.displayName = ln;
var Lr = "PopperAnchor", Wr = a.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Ir(Lr, n), s = a.useRef(null), c = Ie(t, s);
    return a.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ h(Le.div, { ...o, ref: c });
  }
);
Wr.displayName = Lr;
var un = "PopperContent", [cs, ls] = $r(un), Fr = a.forwardRef(
  (e, t) => {
    var Pe, Ee, Se, Re, Ne, Ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: v,
      ...g
    } = e, b = Ir(un, n), [y, w] = a.useState(null), x = Ie(t, (z) => w(z)), [C, P] = a.useState(null), S = Dr(C), E = (S == null ? void 0 : S.width) ?? 0, A = (S == null ? void 0 : S.height) ?? 0, $ = r + (i !== "center" ? "-" + i : ""), T = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, k = Array.isArray(u) ? u : [u], L = k.length > 0, O = {
      padding: T,
      boundary: k.filter(ds),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: M, floatingStyles: W, placement: _, isPositioned: D, middlewareData: R } = Pr({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: $,
      whileElementsMounted: (...z) => xr(...z, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        Er({ mainAxis: o + A, alignmentAxis: s }),
        l && Sr({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Rr() : void 0,
          ...O
        }),
        l && Nr({ ...O }),
        Ar({
          ...O,
          apply: ({ elements: z, rects: Oe, availableWidth: Ct, availableHeight: Pt }) => {
            const { width: Et, height: St } = Oe.reference, ee = z.floating.style;
            ee.setProperty("--radix-popper-available-width", `${Ct}px`), ee.setProperty("--radix-popper-available-height", `${Pt}px`), ee.setProperty("--radix-popper-anchor-width", `${Et}px`), ee.setProperty("--radix-popper-anchor-height", `${St}px`);
          }
        }),
        C && Tr({ element: C, padding: c }),
        fs({ arrowWidth: E, arrowHeight: A }),
        m && Or({ strategy: "referenceHidden", ...O })
      ]
    }), [I, H] = Hr(_), J = te(v);
    V(() => {
      D && (J == null || J());
    }, [D, J]);
    const vt = (Pe = R.arrow) == null ? void 0 : Pe.x, bt = (Ee = R.arrow) == null ? void 0 : Ee.y, yt = ((Se = R.arrow) == null ? void 0 : Se.centerOffset) !== 0, [wt, xt] = a.useState();
    return V(() => {
      y && xt(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ h(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: D ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: wt,
          "--radix-popper-transform-origin": [
            (Re = R.transformOrigin) == null ? void 0 : Re.x,
            (Ne = R.transformOrigin) == null ? void 0 : Ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ae = R.hide) == null ? void 0 : Ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ h(
          cs,
          {
            scope: n,
            placedSide: I,
            onArrowChange: P,
            arrowX: vt,
            arrowY: bt,
            shouldHideArrow: yt,
            children: /* @__PURE__ */ h(
              Le.div,
              {
                "data-side": I,
                "data-align": H,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: D ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Fr.displayName = un;
var Br = "PopperArrow", us = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Vr = a.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = ls(Br, r), s = us[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ h(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ h(
          os,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Vr.displayName = Br;
function ds(e) {
  return e !== null;
}
var fs = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, y, w;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, d] = Hr(n), f = { start: "0%", center: "50%", end: "100%" }[d], m = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + c / 2, p = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = s ? f : `${m}px`, g = `${-l}px`) : u === "top" ? (v = s ? f : `${m}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = s ? f : `${p}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = s ? f : `${p}px`), { data: { x: v, y: g } };
  }
});
function Hr(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ps = kr, zr = Wr, ms = Fr, hs = Vr;
function gs(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vs(...e) {
  return (t) => e.forEach((n) => gs(n, t));
}
var jr = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(ys);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(jt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(jt, { ...r, ref: t, children: n });
});
jr.displayName = "Slot";
var jt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = xs(n);
    return a.cloneElement(n, {
      ...ws(r, n.props),
      // @ts-ignore
      ref: t ? vs(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
jt.displayName = "SlotClone";
var bs = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function ys(e) {
  return a.isValidElement(e) && e.type === bs;
}
function ws(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xs(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Cs = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ps = Cs.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? jr : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Es = "Portal", lt = a.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = a.useState(!1);
  V(() => i(!0), []);
  const s = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return s ? yi.createPortal(/* @__PURE__ */ h(Ps.div, { ...r, ref: t }), s) : null;
});
lt.displayName = Es;
function Ss(e, t) {
  return a.useReducer((n, r) => t[n][r] ?? n, e);
}
var dn = (e) => {
  const { present: t, children: n } = e, r = Rs(t), o = typeof n == "function" ? n({ present: r.isPresent }) : a.Children.only(n), i = Ie(r.ref, Ns(o));
  return typeof n == "function" || r.isPresent ? a.cloneElement(o, { ref: i }) : null;
};
dn.displayName = "Presence";
function Rs(e) {
  const [t, n] = a.useState(), r = a.useRef({}), o = a.useRef(e), i = a.useRef("none"), s = e ? "mounted" : "unmounted", [c, l] = Ss(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const u = je(r.current);
    i.current = c === "mounted" ? u : "none";
  }, [c]), V(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, p = je(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), V(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (p) => {
        const g = je(r.current).includes(p.animationName);
        if (p.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = je(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: a.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function je(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Ns(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function fn({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = As({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, c = te(n), l = a.useCallback(
    (u) => {
      if (i) {
        const f = typeof u == "function" ? u(e) : u;
        f !== e && c(f);
      } else
        o(u);
    },
    [i, e, o, c]
  );
  return [s, l];
}
function As({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [r] = n, o = a.useRef(r), i = te(t);
  return a.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var Os = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, fe = /* @__PURE__ */ new WeakMap(), Ue = /* @__PURE__ */ new WeakMap(), Ye = {}, Dt = 0, Ur = function(e) {
  return e && (e.host || Ur(e.parentNode));
}, Ts = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ur(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Ms = function(e, t, n, r) {
  var o = Ts(t, Array.isArray(e) ? e : [e]);
  Ye[n] || (Ye[n] = /* @__PURE__ */ new WeakMap());
  var i = Ye[n], s = [], c = /* @__PURE__ */ new Set(), l = new Set(o), u = function(f) {
    !f || c.has(f) || (c.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (c.has(m))
        d(m);
      else
        try {
          var p = m.getAttribute(r), v = p !== null && p !== "false", g = (fe.get(m) || 0) + 1, b = (i.get(m) || 0) + 1;
          fe.set(m, g), i.set(m, b), s.push(m), g === 1 && v && Ue.set(m, !0), b === 1 && m.setAttribute(n, "true"), v || m.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", m, y);
        }
    });
  };
  return d(t), c.clear(), Dt++, function() {
    s.forEach(function(f) {
      var m = fe.get(f) - 1, p = i.get(f) - 1;
      fe.set(f, m), i.set(f, p), m || (Ue.has(f) || f.removeAttribute(r), Ue.delete(f)), p || f.removeAttribute(n);
    }), Dt--, Dt || (fe = /* @__PURE__ */ new WeakMap(), fe = /* @__PURE__ */ new WeakMap(), Ue = /* @__PURE__ */ new WeakMap(), Ye = {});
  };
}, Yr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || Os(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Ms(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, G = function() {
  return G = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, G.apply(this, arguments);
};
function Gr(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Ds(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Qe = "right-scroll-bar-position", Je = "width-before-scroll-bar", $s = "with-scroll-bars-hidden", _s = "--removed-body-scroll-bar-size";
function $t(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Is(e, t) {
  var n = bi(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var ks = typeof window < "u" ? a.useLayoutEffect : a.useEffect, zn = /* @__PURE__ */ new WeakMap();
function Ls(e, t) {
  var n = Is(t || null, function(r) {
    return e.forEach(function(o) {
      return $t(o, r);
    });
  });
  return ks(function() {
    var r = zn.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(c) {
        i.has(c) || $t(c, null);
      }), i.forEach(function(c) {
        o.has(c) || $t(c, s);
      });
    }
    zn.set(n, e);
  }, [e]), n;
}
function Ws(e) {
  return e;
}
function Fs(e, t) {
  t === void 0 && (t = Ws);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(c) {
          return c !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), s = n;
      }
      var l = function() {
        var d = s;
        s = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          s.push(d), u();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function Bs(e) {
  e === void 0 && (e = {});
  var t = Fs(null);
  return t.options = G({ async: !0, ssr: !1 }, e), t;
}
var Xr = function(e) {
  var t = e.sideCar, n = Gr(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return a.createElement(r, G({}, n));
};
Xr.isSideCarExport = !0;
function Vs(e, t) {
  return e.useMedium(t), Xr;
}
var Kr = Bs(), _t = function() {
}, ut = a.forwardRef(function(e, t) {
  var n = a.useRef(null), r = a.useState({
    onScrollCapture: _t,
    onWheelCapture: _t,
    onTouchMoveCapture: _t
  }), o = r[0], i = r[1], s = e.forwardProps, c = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, m = e.sideCar, p = e.noIsolation, v = e.inert, g = e.allowPinchZoom, b = e.as, y = b === void 0 ? "div" : b, w = e.gapMode, x = Gr(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = m, P = Ls([n, t]), S = G(G({}, x), o);
  return a.createElement(
    a.Fragment,
    null,
    d && a.createElement(C, { sideCar: Kr, removeScrollBar: u, shards: f, noIsolation: p, inert: v, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: w }),
    s ? a.cloneElement(a.Children.only(c), G(G({}, S), { ref: P })) : a.createElement(y, G({}, S, { className: l, ref: P }), c)
  );
});
ut.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ut.classNames = {
  fullWidth: Je,
  zeroRight: Qe
};
var jn, Hs = function() {
  if (jn)
    return jn;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function zs() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Hs();
  return t && e.setAttribute("nonce", t), e;
}
function js(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Us(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Ys = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = zs()) && (js(t, n), Us(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Gs = function() {
  var e = Ys();
  return function(t, n) {
    a.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Zr = function() {
  var e = Gs(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Xs = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, It = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ks = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [It(n), It(r), It(o)];
}, Zs = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Xs;
  var t = Ks(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, qs = Zr(), ve = "data-scroll-locked", Qs = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat($s, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(ve, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Qe, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(Je, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(Qe, " .").concat(Qe, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Je, " .").concat(Je, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ve, `] {
    `).concat(_s, ": ").concat(c, `px;
  }
`);
}, Un = function() {
  var e = parseInt(document.body.getAttribute(ve) || "0", 10);
  return isFinite(e) ? e : 0;
}, Js = function() {
  a.useEffect(function() {
    return document.body.setAttribute(ve, (Un() + 1).toString()), function() {
      var e = Un() - 1;
      e <= 0 ? document.body.removeAttribute(ve) : document.body.setAttribute(ve, e.toString());
    };
  }, []);
}, ec = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Js();
  var i = a.useMemo(function() {
    return Zs(o);
  }, [o]);
  return a.createElement(qs, { styles: Qs(i, !t, o, n ? "" : "!important") });
}, Ut = !1;
if (typeof window < "u")
  try {
    var Ge = Object.defineProperty({}, "passive", {
      get: function() {
        return Ut = !0, !0;
      }
    });
    window.addEventListener("test", Ge, Ge), window.removeEventListener("test", Ge, Ge);
  } catch {
    Ut = !1;
  }
var pe = Ut ? { passive: !1 } : !1, tc = function(e) {
  return e.tagName === "TEXTAREA";
}, qr = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !tc(e) && n[t] === "visible")
  );
}, nc = function(e) {
  return qr(e, "overflowY");
}, rc = function(e) {
  return qr(e, "overflowX");
}, Yn = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Qr(e, r);
    if (o) {
      var i = Jr(e, r), s = i[1], c = i[2];
      if (s > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, oc = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, ic = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Qr = function(e, t) {
  return e === "v" ? nc(t) : rc(t);
}, Jr = function(e, t) {
  return e === "v" ? oc(t) : ic(t);
}, ac = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, sc = function(e, t, n, r, o) {
  var i = ac(e, window.getComputedStyle(t).direction), s = i * r, c = n.target, l = t.contains(c), u = !1, d = s > 0, f = 0, m = 0;
  do {
    var p = Jr(e, c), v = p[0], g = p[1], b = p[2], y = g - b - i * v;
    (v || y) && Qr(e, c) && (f += y, m += v), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !l && c !== document.body || // self content
    l && (t.contains(c) || t === c)
  );
  return (d && (o && Math.abs(f) < 1 || !o && s > f) || !d && (o && Math.abs(m) < 1 || !o && -s > m)) && (u = !0), u;
}, Xe = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Gn = function(e) {
  return [e.deltaX, e.deltaY];
}, Xn = function(e) {
  return e && "current" in e ? e.current : e;
}, cc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, lc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, uc = 0, me = [];
function dc(e) {
  var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), o = a.useState(uc++)[0], i = a.useState(Zr)[0], s = a.useRef(e);
  a.useEffect(function() {
    s.current = e;
  }, [e]), a.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Ds([e.lockRef.current], (e.shards || []).map(Xn), !0).filter(Boolean);
      return g.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = a.useCallback(function(g, b) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = Xe(g), w = n.current, x = "deltaX" in g ? g.deltaX : w[0] - y[0], C = "deltaY" in g ? g.deltaY : w[1] - y[1], P, S = g.target, E = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && E === "h" && S.type === "range")
      return !1;
    var A = Yn(E, S);
    if (!A)
      return !0;
    if (A ? P = E : (P = E === "v" ? "h" : "v", A = Yn(E, S)), !A)
      return !1;
    if (!r.current && "changedTouches" in g && (x || C) && (r.current = P), !P)
      return !0;
    var $ = r.current || P;
    return sc($, b, g, $ === "h" ? x : C, !0);
  }, []), l = a.useCallback(function(g) {
    var b = g;
    if (!(!me.length || me[me.length - 1] !== i)) {
      var y = "deltaY" in b ? Gn(b) : Xe(b), w = t.current.filter(function(P) {
        return P.name === b.type && (P.target === b.target || b.target === P.shadowParent) && cc(P.delta, y);
      })[0];
      if (w && w.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!w) {
        var x = (s.current.shards || []).map(Xn).filter(Boolean).filter(function(P) {
          return P.contains(b.target);
        }), C = x.length > 0 ? c(b, x[0]) : !s.current.noIsolation;
        C && b.cancelable && b.preventDefault();
      }
    }
  }, []), u = a.useCallback(function(g, b, y, w) {
    var x = { name: g, delta: b, target: y, should: w, shadowParent: fc(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), d = a.useCallback(function(g) {
    n.current = Xe(g), r.current = void 0;
  }, []), f = a.useCallback(function(g) {
    u(g.type, Gn(g), g.target, c(g, e.lockRef.current));
  }, []), m = a.useCallback(function(g) {
    u(g.type, Xe(g), g.target, c(g, e.lockRef.current));
  }, []);
  a.useEffect(function() {
    return me.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, pe), document.addEventListener("touchmove", l, pe), document.addEventListener("touchstart", d, pe), function() {
      me = me.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, pe), document.removeEventListener("touchmove", l, pe), document.removeEventListener("touchstart", d, pe);
    };
  }, []);
  var p = e.removeScrollBar, v = e.inert;
  return a.createElement(
    a.Fragment,
    null,
    v ? a.createElement(i, { styles: lc(o) }) : null,
    p ? a.createElement(ec, { gapMode: e.gapMode }) : null
  );
}
function fc(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const pc = Vs(Kr, dc);
var eo = a.forwardRef(function(e, t) {
  return a.createElement(ut, G({}, e, { ref: t, sideCar: pc }));
});
eo.classNames = ut.classNames;
const to = eo;
var pn = "Popover", [no, Vu] = Qt(pn, [
  _r
]), We = _r(), [mc, ce] = no(pn), ro = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, c = We(t), l = a.useRef(null), [u, d] = a.useState(!1), [f = !1, m] = fn({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ h(ps, { ...c, children: /* @__PURE__ */ h(
    mc,
    {
      scope: t,
      contentId: Me(),
      triggerRef: l,
      open: f,
      onOpenChange: m,
      onOpenToggle: a.useCallback(() => m((p) => !p), [m]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: a.useCallback(() => d(!0), []),
      onCustomAnchorRemove: a.useCallback(() => d(!1), []),
      modal: s,
      children: n
    }
  ) });
};
ro.displayName = pn;
var oo = "PopoverAnchor", io = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ce(oo, n), i = We(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: c } = o;
    return a.useEffect(() => (s(), () => c()), [s, c]), /* @__PURE__ */ h(zr, { ...i, ...r, ref: t });
  }
);
io.displayName = oo;
var ao = "PopoverTrigger", so = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ce(ao, n), i = We(n), s = Ie(t, o.triggerRef), c = /* @__PURE__ */ h(
      Le.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": po(o.open),
        ...r,
        ref: s,
        onClick: Te(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? c : /* @__PURE__ */ h(zr, { asChild: !0, ...i, children: c });
  }
);
so.displayName = ao;
var mn = "PopoverPortal", [hc, gc] = no(mn, {
  forceMount: void 0
}), co = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = ce(mn, t);
  return /* @__PURE__ */ h(hc, { scope: t, forceMount: n, children: /* @__PURE__ */ h(dn, { present: n || i.open, children: /* @__PURE__ */ h(lt, { asChild: !0, container: o, children: r }) }) });
};
co.displayName = mn;
var ye = "PopoverContent", lo = a.forwardRef(
  (e, t) => {
    const n = gc(ye, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = ce(ye, e.__scopePopover);
    return /* @__PURE__ */ h(dn, { present: r || i.open, children: i.modal ? /* @__PURE__ */ h(vc, { ...o, ref: t }) : /* @__PURE__ */ h(bc, { ...o, ref: t }) });
  }
);
lo.displayName = ye;
var vc = a.forwardRef(
  (e, t) => {
    const n = ce(ye, e.__scopePopover), r = a.useRef(null), o = Ie(t, r), i = a.useRef(!1);
    return a.useEffect(() => {
      const s = r.current;
      if (s)
        return Yr(s);
    }, []), /* @__PURE__ */ h(to, { as: cn, allowPinchZoom: !0, children: /* @__PURE__ */ h(
      uo,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Te(e.onCloseAutoFocus, (s) => {
          var c;
          s.preventDefault(), i.current || (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: Te(
          e.onPointerDownOutside,
          (s) => {
            const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
            i.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Te(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), bc = a.forwardRef(
  (e, t) => {
    const n = ce(ye, e.__scopePopover), r = a.useRef(!1), o = a.useRef(!1);
    return /* @__PURE__ */ h(
      uo,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, c;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), uo = a.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: c,
      onPointerDownOutside: l,
      onFocusOutside: u,
      onInteractOutside: d,
      ...f
    } = e, m = ce(ye, n), p = We(n);
    return cr(), /* @__PURE__ */ h(
      Jt,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ h(
          it,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: d,
            onEscapeKeyDown: c,
            onPointerDownOutside: l,
            onFocusOutside: u,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ h(
              ms,
              {
                "data-state": po(m.open),
                role: "dialog",
                id: m.contentId,
                ...p,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), fo = "PopoverClose", yc = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ce(fo, n);
    return /* @__PURE__ */ h(
      Le.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Te(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
yc.displayName = fo;
var wc = "PopoverArrow", xc = a.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = We(n);
    return /* @__PURE__ */ h(hs, { ...o, ...r, ref: t });
  }
);
xc.displayName = wc;
function po(e) {
  return e ? "open" : "closed";
}
var Cc = ro, Pc = io, Ec = so, Sc = co, mo = lo;
const Hu = Cc, zu = Ec, ju = Pc, Rc = a.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ h(Sc, { children: /* @__PURE__ */ h(
  mo,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: N(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
Rc.displayName = mo.displayName;
const ho = a.forwardRef(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ h(
    "input",
    {
      type: t,
      className: N(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: r,
      ...n
    }
  )
);
ho.displayName = "Input";
function Nc(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ac(...e) {
  return (t) => e.forEach((n) => Nc(n, t));
}
var go = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(Tc);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(Yt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Yt, { ...r, ref: t, children: n });
});
go.displayName = "Slot";
var Yt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Dc(n);
    return a.cloneElement(n, {
      ...Mc(r, n.props),
      // @ts-ignore
      ref: t ? Ac(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Yt.displayName = "SlotClone";
var Oc = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function Tc(e) {
  return a.isValidElement(e) && e.type === Oc;
}
function Mc(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Dc(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $c = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], _c = $c.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? go : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ic = "Separator", Kn = "horizontal", kc = ["horizontal", "vertical"], vo = a.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Kn, ...o } = e, i = Lc(r) ? r : Kn, c = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ h(
    _c.div,
    {
      "data-orientation": i,
      ...c,
      ...o,
      ref: t
    }
  );
});
vo.displayName = Ic;
function Lc(e) {
  return kc.includes(e);
}
var bo = vo;
const yo = a.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ h(
    bo,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: N(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
yo.displayName = bo.displayName;
function De(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Wc(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function wo(...e) {
  return (t) => e.forEach((n) => Wc(n, t));
}
function dt(...e) {
  return a.useCallback(wo(...e), e);
}
function Fc(e, t) {
  return a.useReducer((n, r) => t[n][r] ?? n, e);
}
var ft = (e) => {
  const { present: t, children: n } = e, r = Bc(t), o = typeof n == "function" ? n({ present: r.isPresent }) : a.Children.only(n), i = dt(r.ref, Vc(o));
  return typeof n == "function" || r.isPresent ? a.cloneElement(o, { ref: i }) : null;
};
ft.displayName = "Presence";
function Bc(e) {
  const [t, n] = a.useState(), r = a.useRef({}), o = a.useRef(e), i = a.useRef("none"), s = e ? "mounted" : "unmounted", [c, l] = Fc(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const u = Ke(r.current);
    i.current = c === "mounted" ? u : "none";
  }, [c]), V(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, p = Ke(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), V(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (p) => {
        const g = Ke(r.current).includes(p.animationName);
        if (p.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = Ke(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: a.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Ke(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Vc(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hn = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(zc);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(Gt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Gt, { ...r, ref: t, children: n });
});
hn.displayName = "Slot";
var Gt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = Uc(n);
    return a.cloneElement(n, {
      ...jc(r, n.props),
      // @ts-ignore
      ref: t ? wo(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Gt.displayName = "SlotClone";
var Hc = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function zc(e) {
  return a.isValidElement(e) && e.type === Hc;
}
function jc(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Uc(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Yc = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Fe = Yc.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? hn : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), gn = "Dialog", [xo, Uu] = Qt(gn), [Gc, Y] = xo(gn), Co = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, c = a.useRef(null), l = a.useRef(null), [u = !1, d] = fn({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ h(
    Gc,
    {
      scope: t,
      triggerRef: c,
      contentRef: l,
      contentId: Me(),
      titleId: Me(),
      descriptionId: Me(),
      open: u,
      onOpenChange: d,
      onOpenToggle: a.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: n
    }
  );
};
Co.displayName = gn;
var Po = "DialogTrigger", Eo = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Y(Po, n), i = dt(t, o.triggerRef);
    return /* @__PURE__ */ h(
      Fe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": yn(o.open),
        ...r,
        ref: i,
        onClick: De(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Eo.displayName = Po;
var vn = "DialogPortal", [Xc, So] = xo(vn, {
  forceMount: void 0
}), Ro = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Y(vn, t);
  return /* @__PURE__ */ h(Xc, { scope: t, forceMount: n, children: a.Children.map(r, (s) => /* @__PURE__ */ h(ft, { present: n || i.open, children: /* @__PURE__ */ h(lt, { asChild: !0, container: o, children: s }) })) });
};
Ro.displayName = vn;
var ot = "DialogOverlay", No = a.forwardRef(
  (e, t) => {
    const n = So(ot, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Y(ot, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ h(ft, { present: r || i.open, children: /* @__PURE__ */ h(Kc, { ...o, ref: t }) }) : null;
  }
);
No.displayName = ot;
var Kc = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Y(ot, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ h(to, { as: hn, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ h(
        Fe.div,
        {
          "data-state": yn(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), ue = "DialogContent", Ao = a.forwardRef(
  (e, t) => {
    const n = So(ue, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Y(ue, e.__scopeDialog);
    return /* @__PURE__ */ h(ft, { present: r || i.open, children: i.modal ? /* @__PURE__ */ h(Zc, { ...o, ref: t }) : /* @__PURE__ */ h(qc, { ...o, ref: t }) });
  }
);
Ao.displayName = ue;
var Zc = a.forwardRef(
  (e, t) => {
    const n = Y(ue, e.__scopeDialog), r = a.useRef(null), o = dt(t, n.contentRef, r);
    return a.useEffect(() => {
      const i = r.current;
      if (i)
        return Yr(i);
    }, []), /* @__PURE__ */ h(
      Oo,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: De(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: De(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: De(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), qc = a.forwardRef(
  (e, t) => {
    const n = Y(ue, e.__scopeDialog), r = a.useRef(!1), o = a.useRef(!1);
    return /* @__PURE__ */ h(
      Oo,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, c;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Oo = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, c = Y(ue, n), l = a.useRef(null), u = dt(t, l);
    return cr(), /* @__PURE__ */ X(Z, { children: [
      /* @__PURE__ */ h(
        Jt,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ h(
            it,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": yn(c.open),
              ...s,
              ref: u,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ X(Z, { children: [
        /* @__PURE__ */ h(Qc, { titleId: c.titleId }),
        /* @__PURE__ */ h(el, { contentRef: l, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), bn = "DialogTitle", To = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Y(bn, n);
    return /* @__PURE__ */ h(Fe.h2, { id: o.titleId, ...r, ref: t });
  }
);
To.displayName = bn;
var Mo = "DialogDescription", Do = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Y(Mo, n);
    return /* @__PURE__ */ h(Fe.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Do.displayName = Mo;
var $o = "DialogClose", _o = a.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Y($o, n);
    return /* @__PURE__ */ h(
      Fe.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: De(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
_o.displayName = $o;
function yn(e) {
  return e ? "open" : "closed";
}
var Io = "DialogTitleWarning", [Yu, ko] = Ti(Io, {
  contentName: ue,
  titleName: bn,
  docsSlug: "dialog"
}), Qc = ({ titleId: e }) => {
  const t = ko(Io), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return a.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Jc = "DialogDescriptionWarning", el = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ko(Jc).contentName}}.`;
  return a.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, tl = Co, nl = Eo, rl = Ro, Lo = No, Wo = Ao, Fo = To, Bo = Do, Vo = _o;
const ol = tl, Gu = nl, Xu = Vo, il = rl, Ho = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Lo,
  {
    className: N(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
Ho.displayName = Lo.displayName;
const al = qt(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), zo = a.forwardRef(({ side: e = "right", className: t, children: n, ...r }, o) => /* @__PURE__ */ X(il, { children: [
  /* @__PURE__ */ h(Ho, {}),
  /* @__PURE__ */ X(
    Wo,
    {
      ref: o,
      className: N(al({ side: e }), t),
      ...r,
      children: [
        /* @__PURE__ */ X(Vo, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
          /* @__PURE__ */ h(wi, { className: "h-4 w-4" }),
          /* @__PURE__ */ h("span", { className: "sr-only", children: "Close" })
        ] }),
        n
      ]
    }
  )
] }));
zo.displayName = Wo.displayName;
const sl = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: N(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
sl.displayName = "SheetHeader";
const cl = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: N(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
cl.displayName = "SheetFooter";
const ll = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Fo,
  {
    ref: n,
    className: N("text-lg font-semibold text-foreground", e),
    ...t
  }
));
ll.displayName = Fo.displayName;
const ul = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  Bo,
  {
    ref: n,
    className: N("text-sm text-muted-foreground", e),
    ...t
  }
));
ul.displayName = Bo.displayName;
function Zn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ h(
    "div",
    {
      className: N("animate-pulse rounded-md bg-primary/10", e),
      ...t
    }
  );
}
function he(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function dl(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function jo(...e) {
  return (t) => e.forEach((n) => dl(n, t));
}
function Be(...e) {
  return a.useCallback(jo(...e), e);
}
var Uo = a.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = a.Children.toArray(n), i = o.find(fl);
  if (i) {
    const s = i.props.children, c = o.map((l) => l === i ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ h(Xt, { ...r, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ h(Xt, { ...r, ref: t, children: n });
});
Uo.displayName = "Slot";
var Xt = a.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (a.isValidElement(n)) {
    const o = ml(n);
    return a.cloneElement(n, {
      ...pl(r, n.props),
      // @ts-ignore
      ref: t ? jo(t, o) : o
    });
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
Xt.displayName = "SlotClone";
var Yo = ({ children: e }) => /* @__PURE__ */ h(Z, { children: e });
function fl(e) {
  return a.isValidElement(e) && e.type === Yo;
}
function pl(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      i(...c), o(...c);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ml(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ve = hl.reduce((e, t) => {
  const n = a.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? Uo : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), gl = "Arrow", Go = a.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ h(
    Ve.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ h("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Go.displayName = gl;
var vl = Go;
function bl(e, t = []) {
  let n = [];
  function r(i, s) {
    const c = a.createContext(s), l = n.length;
    n = [...n, s];
    function u(f) {
      const { scope: m, children: p, ...v } = f, g = (m == null ? void 0 : m[e][l]) || c, b = a.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ h(g.Provider, { value: b, children: p });
    }
    function d(f, m) {
      const p = (m == null ? void 0 : m[e][l]) || c, v = a.useContext(p);
      if (v)
        return v;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [u, d];
  }
  const o = () => {
    const i = n.map((s) => a.createContext(s));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return o.scopeName = e, [r, yl(o, ...t)];
}
function yl(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((c, { useScope: l, scopeName: u }) => {
        const f = l(i)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var wn = "Popper", [Xo, Ko] = bl(wn), [wl, Zo] = Xo(wn), qo = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = a.useState(null);
  return /* @__PURE__ */ h(wl, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
qo.displayName = wn;
var Qo = "PopperAnchor", Jo = a.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Zo(Qo, n), s = a.useRef(null), c = Be(t, s);
    return a.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ h(Ve.div, { ...o, ref: c });
  }
);
Jo.displayName = Qo;
var xn = "PopperContent", [xl, Cl] = Xo(xn), ei = a.forwardRef(
  (e, t) => {
    var Pe, Ee, Se, Re, Ne, Ae;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: v,
      ...g
    } = e, b = Zo(xn, n), [y, w] = a.useState(null), x = Be(t, (z) => w(z)), [C, P] = a.useState(null), S = Dr(C), E = (S == null ? void 0 : S.width) ?? 0, A = (S == null ? void 0 : S.height) ?? 0, $ = r + (i !== "center" ? "-" + i : ""), T = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, k = Array.isArray(u) ? u : [u], L = k.length > 0, O = {
      padding: T,
      boundary: k.filter(El),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: M, floatingStyles: W, placement: _, isPositioned: D, middlewareData: R } = Pr({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: $,
      whileElementsMounted: (...z) => xr(...z, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        Er({ mainAxis: o + A, alignmentAxis: s }),
        l && Sr({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Rr() : void 0,
          ...O
        }),
        l && Nr({ ...O }),
        Ar({
          ...O,
          apply: ({ elements: z, rects: Oe, availableWidth: Ct, availableHeight: Pt }) => {
            const { width: Et, height: St } = Oe.reference, ee = z.floating.style;
            ee.setProperty("--radix-popper-available-width", `${Ct}px`), ee.setProperty("--radix-popper-available-height", `${Pt}px`), ee.setProperty("--radix-popper-anchor-width", `${Et}px`), ee.setProperty("--radix-popper-anchor-height", `${St}px`);
          }
        }),
        C && Tr({ element: C, padding: c }),
        Sl({ arrowWidth: E, arrowHeight: A }),
        m && Or({ strategy: "referenceHidden", ...O })
      ]
    }), [I, H] = ri(_), J = te(v);
    V(() => {
      D && (J == null || J());
    }, [D, J]);
    const vt = (Pe = R.arrow) == null ? void 0 : Pe.x, bt = (Ee = R.arrow) == null ? void 0 : Ee.y, yt = ((Se = R.arrow) == null ? void 0 : Se.centerOffset) !== 0, [wt, xt] = a.useState();
    return V(() => {
      y && xt(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ h(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: D ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: wt,
          "--radix-popper-transform-origin": [
            (Re = R.transformOrigin) == null ? void 0 : Re.x,
            (Ne = R.transformOrigin) == null ? void 0 : Ne.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Ae = R.hide) == null ? void 0 : Ae.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ h(
          xl,
          {
            scope: n,
            placedSide: I,
            onArrowChange: P,
            arrowX: vt,
            arrowY: bt,
            shouldHideArrow: yt,
            children: /* @__PURE__ */ h(
              Ve.div,
              {
                "data-side": I,
                "data-align": H,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: D ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
ei.displayName = xn;
var ti = "PopperArrow", Pl = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ni = a.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Cl(ti, r), s = Pl[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ h(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ h(
          vl,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ni.displayName = ti;
function El(e) {
  return e !== null;
}
var Sl = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, y, w;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [u, d] = ri(n), f = { start: "0%", center: "50%", end: "100%" }[d], m = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + c / 2, p = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = s ? f : `${m}px`, g = `${-l}px`) : u === "top" ? (v = s ? f : `${m}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = s ? f : `${p}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = s ? f : `${p}px`), { data: { x: v, y: g } };
  }
});
function ri(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Rl = qo, Nl = Jo, Al = ei, Ol = ni;
function Tl(e, t) {
  return a.useReducer((n, r) => t[n][r] ?? n, e);
}
var Cn = (e) => {
  const { present: t, children: n } = e, r = Ml(t), o = typeof n == "function" ? n({ present: r.isPresent }) : a.Children.only(n), i = Be(r.ref, Dl(o));
  return typeof n == "function" || r.isPresent ? a.cloneElement(o, { ref: i }) : null;
};
Cn.displayName = "Presence";
function Ml(e) {
  const [t, n] = a.useState(), r = a.useRef({}), o = a.useRef(e), i = a.useRef("none"), s = e ? "mounted" : "unmounted", [c, l] = Tl(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const u = Ze(r.current);
    i.current = c === "mounted" ? u : "none";
  }, [c]), V(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, p = Ze(u);
      e ? l("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), V(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (p) => {
        const g = Ze(r.current).includes(p.animationName);
        if (p.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = Ze(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: a.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Ze(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Dl(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $l = "VisuallyHidden", oi = a.forwardRef(
  (e, t) => /* @__PURE__ */ h(
    Ve.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
oi.displayName = $l;
var _l = oi, [pt, Ku] = Qt("Tooltip", [
  Ko
]), mt = Ko(), ii = "TooltipProvider", Il = 700, Kt = "tooltip.open", [kl, Pn] = pt(ii), ai = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Il,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [s, c] = a.useState(!0), l = a.useRef(!1), u = a.useRef(0);
  return a.useEffect(() => {
    const d = u.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ h(
    kl,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: a.useCallback(() => {
        window.clearTimeout(u.current), c(!1);
      }, []),
      onClose: a.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => c(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: a.useCallback((d) => {
        l.current = d;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
ai.displayName = ii;
var ht = "Tooltip", [Ll, He] = pt(ht), si = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: c
  } = e, l = Pn(ht, e.__scopeTooltip), u = mt(t), [d, f] = a.useState(null), m = Me(), p = a.useRef(0), v = s ?? l.disableHoverableContent, g = c ?? l.delayDuration, b = a.useRef(!1), [y = !1, w] = fn({
    prop: r,
    defaultProp: o,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Kt))) : l.onClose(), i == null || i(E);
    }
  }), x = a.useMemo(() => y ? b.current ? "delayed-open" : "instant-open" : "closed", [y]), C = a.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, b.current = !1, w(!0);
  }, [w]), P = a.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, w(!1);
  }, [w]), S = a.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      b.current = !0, w(!0), p.current = 0;
    }, g);
  }, [g, w]);
  return a.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ h(Rl, { ...u, children: /* @__PURE__ */ h(
    Ll,
    {
      scope: t,
      contentId: m,
      open: y,
      stateAttribute: x,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: a.useCallback(() => {
        l.isOpenDelayed ? S() : C();
      }, [l.isOpenDelayed, S, C]),
      onTriggerLeave: a.useCallback(() => {
        v ? P() : (window.clearTimeout(p.current), p.current = 0);
      }, [P, v]),
      onOpen: C,
      onClose: P,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
si.displayName = ht;
var Zt = "TooltipTrigger", ci = a.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = He(Zt, n), i = Pn(Zt, n), s = mt(n), c = a.useRef(null), l = Be(t, c, o.onTriggerChange), u = a.useRef(!1), d = a.useRef(!1), f = a.useCallback(() => u.current = !1, []);
    return a.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ h(Nl, { asChild: !0, ...s, children: /* @__PURE__ */ h(
      Ve.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: he(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !d.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: he(e.onPointerLeave, () => {
          o.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: he(e.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: he(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: he(e.onBlur, o.onClose),
        onClick: he(e.onClick, o.onClose)
      }
    ) });
  }
);
ci.displayName = Zt;
var En = "TooltipPortal", [Wl, Fl] = pt(En, {
  forceMount: void 0
}), li = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = He(En, t);
  return /* @__PURE__ */ h(Wl, { scope: t, forceMount: n, children: /* @__PURE__ */ h(Cn, { present: n || i.open, children: /* @__PURE__ */ h(lt, { asChild: !0, container: o, children: r }) }) });
};
li.displayName = En;
var we = "TooltipContent", ui = a.forwardRef(
  (e, t) => {
    const n = Fl(we, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, s = He(we, e.__scopeTooltip);
    return /* @__PURE__ */ h(Cn, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ h(di, { side: o, ...i, ref: t }) : /* @__PURE__ */ h(Bl, { side: o, ...i, ref: t }) });
  }
), Bl = a.forwardRef((e, t) => {
  const n = He(we, e.__scopeTooltip), r = Pn(we, e.__scopeTooltip), o = a.useRef(null), i = Be(t, o), [s, c] = a.useState(null), { trigger: l, onClose: u } = n, d = o.current, { onPointerInTransitChange: f } = r, m = a.useCallback(() => {
    c(null), f(!1);
  }, [f]), p = a.useCallback(
    (v, g) => {
      const b = v.currentTarget, y = { x: v.clientX, y: v.clientY }, w = jl(y, b.getBoundingClientRect()), x = Ul(y, w), C = Yl(g.getBoundingClientRect()), P = Xl([...x, ...C]);
      c(P), f(!0);
    },
    [f]
  );
  return a.useEffect(() => () => m(), [m]), a.useEffect(() => {
    if (l && d) {
      const v = (b) => p(b, d), g = (b) => p(b, l);
      return l.addEventListener("pointerleave", v), d.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", v), d.removeEventListener("pointerleave", g);
      };
    }
  }, [l, d, p, m]), a.useEffect(() => {
    if (s) {
      const v = (g) => {
        const b = g.target, y = { x: g.clientX, y: g.clientY }, w = (l == null ? void 0 : l.contains(b)) || (d == null ? void 0 : d.contains(b)), x = !Gl(y, s);
        w ? m() : x && (m(), u());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, d, s, u, m]), /* @__PURE__ */ h(di, { ...e, ref: i });
}), [Vl, Hl] = pt(ht, { isInside: !1 }), di = a.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...c
    } = e, l = He(we, n), u = mt(n), { onClose: d } = l;
    return a.useEffect(() => (document.addEventListener(Kt, d), () => document.removeEventListener(Kt, d)), [d]), a.useEffect(() => {
      if (l.trigger) {
        const f = (m) => {
          const p = m.target;
          p != null && p.contains(l.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, d]), /* @__PURE__ */ h(
      it,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ X(
          Al,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...c,
            ref: t,
            style: {
              ...c.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ h(Yo, { children: r }),
              /* @__PURE__ */ h(Vl, { scope: n, isInside: !0, children: /* @__PURE__ */ h(_l, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
ui.displayName = we;
var fi = "TooltipArrow", zl = a.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = mt(n);
    return Hl(
      fi,
      n
    ).isInside ? null : /* @__PURE__ */ h(Ol, { ...o, ...r, ref: t });
  }
);
zl.displayName = fi;
function jl(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Ul(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Yl(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function Gl(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const c = t[i].x, l = t[i].y, u = t[s].x, d = t[s].y;
    l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (o = !o);
  }
  return o;
}
function Xl(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Kl(t);
}
function Kl(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var Zl = ai, ql = si, Ql = ci, Jl = li, pi = ui;
const eu = Zl, tu = ql, nu = Ql, mi = a.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ h(Jl, { children: /* @__PURE__ */ h(
  pi,
  {
    ref: r,
    sideOffset: t,
    className: N(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
mi.displayName = pi.displayName;
const ru = "sidebar:state", ou = 60 * 60 * 24 * 7, iu = "16rem", au = "18rem", su = "3rem", cu = "b", hi = a.createContext(null);
function gt() {
  const e = a.useContext(hi);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
const lu = a.forwardRef(
  ({
    defaultOpen: e = !0,
    open: t,
    onOpenChange: n,
    className: r,
    style: o,
    children: i,
    ...s
  }, c) => {
    const l = Ci(), [u, d] = a.useState(!1), [f, m] = a.useState(e), p = t ?? f, v = a.useCallback(
      (w) => {
        const x = typeof w == "function" ? w(p) : w;
        n ? n(x) : m(x), document.cookie = `${ru}=${x}; path=/; max-age=${ou}`;
      },
      [n, p]
    ), g = a.useCallback(() => l ? d((w) => !w) : v((w) => !w), [l, v, d]);
    a.useEffect(() => {
      const w = (x) => {
        x.key === cu && (x.metaKey || x.ctrlKey) && (x.preventDefault(), g());
      };
      return window.addEventListener("keydown", w), () => window.removeEventListener("keydown", w);
    }, [g]);
    const b = p ? "expanded" : "collapsed", y = a.useMemo(
      () => ({
        state: b,
        open: p,
        setOpen: v,
        isMobile: l,
        openMobile: u,
        setOpenMobile: d,
        toggleSidebar: g
      }),
      [b, p, v, l, u, d, g]
    );
    return /* @__PURE__ */ h(hi.Provider, { value: y, children: /* @__PURE__ */ h(eu, { delayDuration: 0, children: /* @__PURE__ */ h(
      "div",
      {
        style: {
          "--sidebar-width": iu,
          "--sidebar-width-icon": su,
          ...o
        },
        className: N(
          "group/sidebar-wrapper flex min-h-svh w-full has-[[data-variant=inset]]:bg-sidebar",
          r
        ),
        ref: c,
        ...s,
        children: i
      }
    ) }) });
  }
);
lu.displayName = "SidebarProvider";
const uu = a.forwardRef(
  ({
    side: e = "left",
    variant: t = "sidebar",
    collapsible: n = "offcanvas",
    className: r,
    children: o,
    ...i
  }, s) => {
    const { isMobile: c, state: l, openMobile: u, setOpenMobile: d } = gt();
    return n === "none" ? /* @__PURE__ */ h(
      "div",
      {
        className: N(
          "flex h-full w-[--sidebar-width] flex-col bg-sidebar text-sidebar-foreground",
          r
        ),
        ref: s,
        ...i,
        children: o
      }
    ) : c ? /* @__PURE__ */ h(ol, { open: u, onOpenChange: d, ...i, children: /* @__PURE__ */ h(
      zo,
      {
        "data-sidebar": "sidebar",
        "data-mobile": "true",
        className: "w-[--sidebar-width] bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
        style: {
          "--sidebar-width": au
        },
        side: e,
        children: /* @__PURE__ */ h("div", { className: "flex h-full w-full flex-col", children: o })
      }
    ) }) : /* @__PURE__ */ X(
      "div",
      {
        ref: s,
        className: "group peer hidden md:block text-sidebar-foreground",
        "data-state": l,
        "data-collapsible": l === "collapsed" ? n : "",
        "data-variant": t,
        "data-side": e,
        children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: N(
                "duration-200 relative h-svh w-[--sidebar-width] bg-transparent transition-[width] ease-linear",
                "group-data-[collapsible=offcanvas]:w-0",
                "group-data-[side=right]:rotate-180",
                t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-[--sidebar-width-icon]"
              )
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: N(
                "duration-200 fixed inset-y-0 z-10 hidden h-svh w-[--sidebar-width] transition-[left,right,width] ease-linear md:flex",
                e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-[--sidebar-width-icon] group-data-[side=left]:border-r group-data-[side=right]:border-l",
                r
              ),
              ...i,
              children: /* @__PURE__ */ h(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: "flex h-full w-full flex-col bg-sidebar group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow",
                  children: o
                }
              )
            }
          )
        ]
      }
    );
  }
);
uu.displayName = "Sidebar";
const du = a.forwardRef(({ className: e, onClick: t, ...n }, r) => {
  const { toggleSidebar: o } = gt();
  return /* @__PURE__ */ X(
    er,
    {
      ref: r,
      "data-sidebar": "trigger",
      variant: "ghost",
      size: "icon",
      className: N("h-7 w-7", e),
      onClick: (i) => {
        t == null || t(i), o();
      },
      ...n,
      children: [
        /* @__PURE__ */ h(xi, {}),
        /* @__PURE__ */ h("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
});
du.displayName = "SidebarTrigger";
const fu = a.forwardRef(({ className: e, ...t }, n) => {
  const { toggleSidebar: r } = gt();
  return /* @__PURE__ */ h(
    "button",
    {
      ref: n,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: N(
        "absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-sidebar-border group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex",
        "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full group-data-[collapsible=offcanvas]:hover:bg-sidebar",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
});
fu.displayName = "SidebarRail";
const pu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "main",
  {
    ref: n,
    className: N(
      "relative flex min-h-svh flex-1 flex-col bg-background",
      "peer-data-[variant=inset]:min-h-[calc(100svh-theme(spacing.4))] md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow",
      e
    ),
    ...t
  }
));
pu.displayName = "SidebarInset";
const mu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  ho,
  {
    ref: n,
    "data-sidebar": "input",
    className: N(
      "h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring",
      e
    ),
    ...t
  }
));
mu.displayName = "SidebarInput";
const hu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "header",
    className: N("flex flex-col gap-2 p-2", e),
    ...t
  }
));
hu.displayName = "SidebarHeader";
const gu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "footer",
    className: N("flex flex-col gap-2 p-2", e),
    ...t
  }
));
gu.displayName = "SidebarFooter";
const vu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  yo,
  {
    ref: n,
    "data-sidebar": "separator",
    className: N("mx-2 w-auto bg-sidebar-border", e),
    ...t
  }
));
vu.displayName = "SidebarSeparator";
const bu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "content",
    className: N(
      "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
      e
    ),
    ...t
  }
));
bu.displayName = "SidebarContent";
const yu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "group",
    className: N("relative flex w-full min-w-0 flex-col p-2", e),
    ...t
  }
));
yu.displayName = "SidebarGroup";
const wu = a.forwardRef(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ h(
  t ? de : "div",
  {
    ref: r,
    "data-sidebar": "group-label",
    className: N(
      "duration-200 flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium text-sidebar-foreground/70 outline-none ring-sidebar-ring transition-[margin,opa] ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
      e
    ),
    ...n
  }
));
wu.displayName = "SidebarGroupLabel";
const xu = a.forwardRef(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ h(
  t ? de : "button",
  {
    ref: r,
    "data-sidebar": "group-action",
    className: N(
      "absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...n
  }
));
xu.displayName = "SidebarGroupAction";
const Cu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "group-content",
    className: N("w-full text-sm", e),
    ...t
  }
));
Cu.displayName = "SidebarGroupContent";
const Pu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu",
    className: N("flex w-full min-w-0 flex-col gap-1", e),
    ...t
  }
));
Pu.displayName = "SidebarMenu";
const Eu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "li",
  {
    ref: n,
    "data-sidebar": "menu-item",
    className: N("group/menu-item relative", e),
    ...t
  }
));
Eu.displayName = "SidebarMenuItem";
const Su = qt(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:!p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ru = a.forwardRef(
  ({
    asChild: e = !1,
    isActive: t = !1,
    variant: n = "default",
    size: r = "default",
    tooltip: o,
    className: i,
    ...s
  }, c) => {
    const l = e ? de : "button", { isMobile: u, state: d } = gt(), f = /* @__PURE__ */ h(
      l,
      {
        ref: c,
        "data-sidebar": "menu-button",
        "data-size": r,
        "data-active": t,
        className: N(Su({ variant: n, size: r }), i),
        ...s
      }
    );
    return o ? (typeof o == "string" && (o = {
      children: o
    }), /* @__PURE__ */ X(tu, { children: [
      /* @__PURE__ */ h(nu, { asChild: !0, children: f }),
      /* @__PURE__ */ h(
        mi,
        {
          side: "right",
          align: "center",
          hidden: d !== "collapsed" || u,
          ...o
        }
      )
    ] })) : f;
  }
);
Ru.displayName = "SidebarMenuButton";
const Nu = a.forwardRef(({ className: e, asChild: t = !1, showOnHover: n = !1, ...r }, o) => /* @__PURE__ */ h(
  t ? de : "button",
  {
    ref: o,
    "data-sidebar": "menu-action",
    className: N(
      "absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 peer-hover/menu-button:text-sidebar-accent-foreground [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      n && "group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 peer-data-[active=true]/menu-button:text-sidebar-accent-foreground md:opacity-0",
      e
    ),
    ...r
  }
));
Nu.displayName = "SidebarMenuAction";
const Au = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "div",
  {
    ref: n,
    "data-sidebar": "menu-badge",
    className: N(
      "absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums text-sidebar-foreground select-none pointer-events-none",
      "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
Au.displayName = "SidebarMenuBadge";
const Ou = a.forwardRef(({ className: e, showIcon: t = !1, ...n }, r) => {
  const o = a.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ X(
    "div",
    {
      ref: r,
      "data-sidebar": "menu-skeleton",
      className: N("rounded-md h-8 flex gap-2 px-2 items-center", e),
      ...n,
      children: [
        t && /* @__PURE__ */ h(
          Zn,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ h(
          Zn,
          {
            className: "h-4 flex-1 max-w-[--skeleton-width]",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": o
            }
          }
        )
      ]
    }
  );
});
Ou.displayName = "SidebarMenuSkeleton";
const Tu = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ h(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu-sub",
    className: N(
      "mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
Tu.displayName = "SidebarMenuSub";
const Mu = a.forwardRef(({ ...e }, t) => /* @__PURE__ */ h("li", { ref: t, ...e }));
Mu.displayName = "SidebarMenuSubItem";
const Du = a.forwardRef(({ asChild: e = !1, size: t = "md", isActive: n, className: r, ...o }, i) => /* @__PURE__ */ h(
  e ? de : "a",
  {
    ref: i,
    "data-sidebar": "menu-sub-button",
    "data-size": t,
    "data-active": n,
    className: N(
      "flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-sidebar-foreground outline-none ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground",
      "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
      t === "sm" && "text-xs",
      t === "md" && "text-sm",
      "group-data-[collapsible=icon]:hidden",
      r
    ),
    ...o
  }
));
Du.displayName = "SidebarMenuSubButton";
export {
  Vs as $,
  Nr as A,
  er as B,
  Ar as C,
  Tr as D,
  Or as E,
  fn as F,
  Me as G,
  Yr as H,
  cr as I,
  Jt as J,
  it as K,
  lt as L,
  Bu as M,
  de as N,
  Fi as O,
  Hu as P,
  Bs as Q,
  to as R,
  uu as S,
  Ls as T,
  G as U,
  Je as V,
  Qe as W,
  Zr as X,
  Ds as Y,
  ec as Z,
  Gr as _,
  zu as a,
  Ti as a0,
  Ei as a1,
  Ai as a2,
  qt as a3,
  Lo as a4,
  Wo as a5,
  Vo as a6,
  Fo as a7,
  Bo as a8,
  rl as a9,
  tu as aA,
  nu as aB,
  mi as aC,
  eu as aD,
  tl as aa,
  nl as ab,
  ho as ac,
  ju as ad,
  ol as ae,
  il as af,
  Ho as ag,
  Gu as ah,
  Xu as ai,
  zo as aj,
  sl as ak,
  cl as al,
  ll as am,
  ul as an,
  xu as ao,
  wu as ap,
  mu as aq,
  Nu as ar,
  Au as as,
  Ou as at,
  Tu as au,
  Du as av,
  Mu as aw,
  fu as ax,
  vu as ay,
  Zn as az,
  Rc as b,
  bu as c,
  Pu as d,
  Eu as e,
  Ru as f,
  hu as g,
  yu as h,
  Cu as i,
  gu as j,
  lu as k,
  pu as l,
  du as m,
  yo as n,
  Jn as o,
  Qt as p,
  te as q,
  V as r,
  N as s,
  Dr as t,
  gt as u,
  Pr as v,
  xr as w,
  Er as x,
  Sr as y,
  Rr as z
};
